import { Component, inject } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from 'models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { FaDirectiveEnum } from '../../../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-modal-list-error',
  templateUrl: './bary-modal-list-error.component.html',
})
export class BaryModalListErrorComponent {
  readonly modalRef = inject(MDBModalRef);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();

  public title?: string;

  public errors: string[] = [];
  public buttons = {
    first: '',
    second: '',
  };
  public class = '';

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }
}
